module.exports = __webpack_public_path__ + "static/media/QRCode.d4d1c5ba.png";